<template lang="pug">
main.modal-wrapper
    svg-icon.close-modal.cursor(name='close' size="small" @click.native="closeModal")

    main.modal-main
        header.modal-header
            sectionHeader(title="Bootstrap period")

        div.modal-content
            div.l-flex-row--center.l-align-center
                label Set a bootstrap period
                select.form-select.select-bootstrap(v-model="bootstrapPeriodSelected")
                    option(v-for="period of bootstrapPeriodList" :value="period") {{ period }} {{ period === 1 ? 'day': 'days' }}

        footer.modal-footer
            div.footer-content.l-flex-row--between
                button.btn.btn--medium.btn--round(@click="closeModal()") Cancel
                button.btn.btn--medium.btn--round.btn-rev(@click="updateBootstrap") Bootstrap
</template>

<script>
import { isArray, isEmpty } from 'lodash'

//components
import SectionHeader from '@/components/common/SectionHeader'

export default {
    name: 'FormBootstrapAudience',
    components: { SectionHeader },

    props: {
        selectedAudience: { type: Object, required: true },
        editBootstrap: { type: Function, required: true },
        closeModal: { type: Function, required: true }
    },

    mounted() {
        this.bootstrapPeriodSelected = this.bootstrapPeriodList.at(-1)
    },

    data() {
        return { bootstrapPeriodSelected: 30 }
    },

    computed: {
        bootstrapPeriodList() {
            const formula = this.selectedAudience.formula
            const formatFormula = isArray(formula) ? formula : [formula]
            const crmInFormula = formatFormula.filter(x => {
                if (Array.isArray(x) && x?.[0] === '!') {
                    return x.some(i => i.recency === 395 && (i.type === 'CustomSegment' || i.type === 'Audience'))
                }
                return x.recency === 395 && (x.type === 'CustomSegment' || x.type === 'Audience')
            })
            const range = Array(this.selectedAudience.maxRecency === 395 ? 30 : this.selectedAudience.maxRecency)
                .fill(1)
                .map((n, i) => n + i)

            return isEmpty(crmInFormula) ? range : [...range, 395]
        }
    },

    methods: {
        updateBootstrap() {
            this.editBootstrap('bootstrap', { bootstrap: 'attribute', bootstrap_period: this.bootstrapPeriodSelected })
        }
    }
}
</script>
